import { GET_GROUPS } from "../../../actions/clients/groups/groups";

export default function groups(state = [], action) {
  switch (action.type) {
    case GET_GROUPS:
      return action.groups;
    default:
      return state;
  }
}
